var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 296.42,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 35.93
  }), /*#__PURE__*/React.createElement("rect", {
    y: 368.28,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 35.93
  })), /*#__PURE__*/React.createElement("rect", {
    y: 332.35,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 35.93
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M185.465,223.434l4.133,12.391l13.062,0.101c1.012,0.008,1.432,1.299,0.617,1.9l-10.508,7.759   l3.94,12.454c0.305,0.965-0.793,1.763-1.617,1.174l-10.627-7.596l-10.627,7.596c-0.823,0.588-1.922-0.21-1.617-1.174l3.94-12.454   l-10.508-7.759c-0.814-0.601-0.394-1.893,0.617-1.9l13.062-0.101l4.133-12.391C183.787,222.474,185.144,222.474,185.465,223.434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M185.465,441.174l4.133,12.391l13.062,0.101c1.012,0.008,1.432,1.299,0.617,1.9l-10.508,7.759   l3.94,12.454c0.305,0.965-0.793,1.763-1.617,1.174l-10.627-7.596l-10.627,7.596c-0.823,0.588-1.922-0.21-1.617-1.174l3.94-12.454   l-10.508-7.759c-0.814-0.601-0.394-1.893,0.617-1.9l13.062-0.101l4.133-12.391C183.787,440.214,185.144,440.214,185.465,441.174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M114.785,453.342l10.503-7.765L136.035,453c0.833,0.575,1.918-0.241,1.597-1.2l-4.139-12.389   l10.382-7.927c0.804-0.614,0.364-1.899-0.648-1.89l-13.062,0.109l-4.331-12.323c-0.336-0.955-1.693-0.933-1.998,0.032   l-3.933,12.456l-13.058,0.311c-1.012,0.024-1.41,1.322-0.587,1.91l10.631,7.59l-3.739,12.515   C112.86,453.163,113.971,453.943,114.785,453.342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M135.791,276.332l-10.665-7.542l-10.588,7.649c-0.82,0.593-1.923-0.2-1.622-1.166l3.877-12.473   l-10.546-7.706c-0.817-0.597-0.404-1.891,0.608-1.903l13.061-0.167l4.07-12.412c0.315-0.962,1.673-0.968,1.998-0.01l4.195,12.37   l13.062,0.036c1.012,0.003,1.438,1.292,0.627,1.897l-10.468,7.812l4.003,12.434C137.712,276.113,136.617,276.917,135.791,276.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M234.159,276.492l10.503-7.765l10.747,7.424c0.833,0.575,1.918-0.241,1.598-1.2l-4.14-12.389   l10.382-7.927c0.804-0.614,0.364-1.899-0.648-1.89l-13.062,0.109l-4.331-12.323c-0.336-0.955-1.693-0.933-1.998,0.032   l-3.933,12.456l-13.058,0.311c-1.012,0.024-1.41,1.322-0.587,1.91l10.631,7.59l-3.739,12.515   C232.234,276.313,233.345,277.094,234.159,276.492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M255.166,453.182l-10.665-7.542l-10.588,7.649c-0.82,0.593-1.923-0.2-1.622-1.166l3.877-12.473   l-10.546-7.706c-0.817-0.597-0.404-1.891,0.608-1.903l13.061-0.167l4.07-12.412c0.315-0.962,1.673-0.968,1.998-0.01l4.195,12.37   l13.062,0.036c1.012,0.003,1.438,1.292,0.627,1.897l-10.468,7.812l4.003,12.434C257.086,452.962,255.992,453.766,255.166,453.182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M99.163,377.077l-13.062,0.087l-4.31-12.33c-0.334-0.955-1.692-0.936-1.998,0.029l-3.954,12.449   l-13.059,0.289c-1.012,0.022-1.413,1.32-0.59,1.909l10.618,7.607l-3.76,12.509c-0.291,0.969,0.819,1.751,1.633,1.151l10.516-7.748   l10.735,7.442c0.832,0.577,1.919-0.237,1.599-1.198l-4.119-12.396l10.395-7.91C100.613,378.356,100.175,377.07,99.163,377.077z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M62.783,309.943l13.06-0.247l3.994-12.436c0.309-0.963,1.667-0.979,1.998-0.022l4.27,12.344   l13.062-0.044c1.012-0.003,1.446,1.283,0.639,1.893l-10.421,7.876l4.078,12.409c0.316,0.961-0.774,1.772-1.603,1.192l-10.711-7.477   l-10.541,7.713c-0.817,0.598-1.924-0.188-1.63-1.156l3.801-12.497l-10.593-7.642C61.366,311.258,61.771,309.962,62.783,309.943z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M306.12,309.461l-13.062,0.087l-4.31-12.33c-0.334-0.955-1.692-0.936-1.998,0.029l-3.954,12.449   l-13.059,0.289c-1.012,0.022-1.413,1.32-0.59,1.909l10.618,7.607l-3.76,12.509c-0.291,0.969,0.819,1.751,1.633,1.151l10.516-7.748   l10.735,7.442c0.832,0.577,1.919-0.237,1.599-1.198l-4.119-12.396l10.395-7.91C307.57,310.739,307.132,309.454,306.12,309.461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M269.74,377.56l13.06-0.247l3.994-12.436c0.309-0.963,1.667-0.979,1.998-0.022l4.27,12.344   l13.062-0.044c1.012-0.003,1.446,1.283,0.639,1.893l-10.421,7.876l4.078,12.409c0.316,0.961-0.774,1.772-1.603,1.192l-10.711-7.477   l-10.541,7.713c-0.817,0.598-1.924-0.188-1.63-1.156l3.801-12.497l-10.593-7.642C268.323,378.875,268.728,377.579,269.74,377.56z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCv);
export default __webpack_public_path__ + "static/media/cv.6fb0765481b9fa0bf5c9ce438344c749.svg";
export { ForwardRef as ReactComponent };